import { Component } from '@angular/core';

@Component({
    template: `<br><br><h2 class="text-center">Page not found</h2>`
})
export class PageNotFoundComponent {
}